import React from "react";

/**
 * Tiny markdown-bold renderer. Splits on `**…**` and wraps each match in
 * <strong>. Everything else renders as plain text. No new dependency.
 *
 * We use this for admin-curated startup ideas whose descriptions follow the
 * "Starter brief" format: **Problem** … **Who feels it** … **MVP hint** …
 */
export function RichText({ text, className }) {
    if (!text) return null;
    const parts = String(text).split(/(\*\*[^*]+\*\*)/g);
    return (
        <span className={className}>
            {parts.map((seg, i) => {
                if (seg.startsWith("**") && seg.endsWith("**")) {
                    return (
                        <strong key={i} className="font-semibold text-foreground">
                            {seg.slice(2, -2)}
                        </strong>
                    );
                }
                return <React.Fragment key={i}>{seg}</React.Fragment>;
            })}
        </span>
    );
}

export default RichText;
